function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M26.015 51.01c14.115 0 25.558-11.317 25.558-25.277S40.13.456 26.015.456.457 11.773.457 25.733 11.9 51.01 26.015 51.01z",
  fill: "#005398"
});

var _ref2 = /*#__PURE__*/React.createElement("mask", {
  id: "logo_svg__a",
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 52,
  height: 52
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__pattern0)",
  d: "M0 0h52v51.429H0z"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#logo_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  opacity: 0.75,
  d: "M26.015 51.01c14.115 0 25.558-11.317 25.558-25.277S40.13.456 26.015.456.457 11.773.457 25.733 11.9 51.01 26.015 51.01z",
  fill: "#fff"
}));

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M26.015 47.816c12.332 0 22.329-9.887 22.329-22.083 0-12.196-9.997-22.083-22.329-22.083S3.686 13.537 3.686 25.733c0 12.196 9.997 22.083 22.33 22.083z",
  fill: "#fff"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M13.092 20.608h2.95c.342 0 .688.025 1.034.072.346.048.658.143.932.288.277.143.499.345.67.604.173.259.259.6.259 1.027 0 .442-.126.809-.376 1.1-.249.291-.58.5-.988.625v.022c.26.038.496.108.71.216.211.108.394.242.547.408.153.166.27.359.352.58.082.222.123.459.123.707 0 .413-.09.757-.268 1.034-.178.276-.41.5-.693.67-.283.17-.602.29-.956.365-.354.074-.706.11-1.056.11H13.09v-7.828h.002zm1.744 3.13h1.263c.134 0 .267-.015.396-.044a1.1 1.1 0 00.352-.143.75.75 0 00.252-.265.789.789 0 00.094-.398.717.717 0 00-.107-.405.732.732 0 00-.274-.248 1.309 1.309 0 00-.38-.127 2.393 2.393 0 00-.412-.039h-1.184v1.668zm0 3.238H16.4c.134 0 .27-.014.409-.043a1.07 1.07 0 00.375-.155.818.818 0 00.381-.72.679.679 0 00-.14-.447.879.879 0 00-.352-.26 1.89 1.89 0 00-.46-.122 3.324 3.324 0 00-.458-.033h-1.318v1.78h-.002zM30.252 20.608h1.441l3.443 7.827h-1.968l-.68-1.657h-3.075l-.66 1.657h-1.921l3.42-7.827zm.67 2.277l-.962 2.433h1.934l-.972-2.433zM35.626 22.133h-2.258v-1.525h6.258v1.525H37.37v6.3h-1.744v-6.3z",
  fill: "#000"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M23.567 28.667c2.294 0 4.153-1.839 4.153-4.107 0-2.269-1.86-4.107-4.153-4.107-2.294 0-4.153 1.838-4.153 4.107 0 2.268 1.86 4.107 4.153 4.107z",
  fill: "#005398"
});

var _ref7 = /*#__PURE__*/React.createElement("mask", {
  id: "logo_svg__b",
  maskUnits: "userSpaceOnUse",
  x: 18,
  y: 19,
  width: 11,
  height: 11
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__pattern1)",
  d: "M18.96 19.994h9.203v9.102H18.96z"
}));

var _ref8 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#logo_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  opacity: 0.75,
  d: "M23.567 28.667c2.294 0 4.153-1.839 4.153-4.107 0-2.269-1.86-4.107-4.153-4.107-2.294 0-4.153 1.838-4.153 4.107 0 2.268 1.86 4.107 4.153 4.107z",
  fill: "#fff"
}));

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M23.567 27.152c1.448 0 2.622-1.16 2.622-2.592 0-1.432-1.174-2.593-2.622-2.593s-2.621 1.161-2.621 2.593 1.173 2.593 2.621 2.593z",
  fill: "#fff"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M14.768 30.95a1.25 1.25 0 00-.576-.392 2.08 2.08 0 00-.687-.127 1.84 1.84 0 00-.392.044c-.134.029-.26.074-.38.138a.826.826 0 00-.29.25.618.618 0 00-.111.374c0 .237.09.417.268.541.178.127.404.232.677.321.272.09.563.177.878.266.312.089.605.213.878.375.272.161.496.379.676.652.178.274.268.639.268 1.095 0 .435-.081.814-.245 1.137a2.319 2.319 0 01-.664.807 2.809 2.809 0 01-.972.474 4.3 4.3 0 01-1.167.156c-.514 0-.992-.077-1.431-.233a3.62 3.62 0 01-1.23-.752l1.24-1.349c.178.236.404.419.677.547a1.91 1.91 0 001.274.143 1.42 1.42 0 00.392-.149.821.821 0 00.278-.255.624.624 0 00.107-.365.657.657 0 00-.274-.557 2.523 2.523 0 00-.688-.348c-.276-.096-.574-.19-.894-.288a3.964 3.964 0 01-.895-.388 2.126 2.126 0 01-.687-.64c-.183-.266-.275-.616-.275-1.05 0-.422.084-.788.252-1.105.167-.318.391-.583.67-.796.279-.214.601-.373.966-.481.365-.108.742-.16 1.13-.16.446 0 .88.063 1.297.189.417.126.794.336 1.129.63l-1.199 1.295zM16.375 29.038h1.744v2.918h3.386v-2.918h1.743v7.828h-1.743v-3.382h-3.386v3.382h-1.744v-7.828zM31.233 29.038h1.9l1.264 5.02h.023l1.653-5.02h1.62l1.643 5.152h.023l1.33-5.152h1.767l-2.314 7.828H38.59l-1.743-5.417h-.023l-1.743 5.417H33.58l-2.349-7.828z",
  fill: "#000"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M27.743 37.098c2.294 0 4.154-1.84 4.154-4.108s-1.86-4.107-4.154-4.107c-2.293 0-4.153 1.839-4.153 4.107 0 2.269 1.86 4.108 4.153 4.108z",
  fill: "#005398"
});

var _ref12 = /*#__PURE__*/React.createElement("mask", {
  id: "logo_svg__c",
  maskUnits: "userSpaceOnUse",
  x: 23,
  y: 28,
  width: 10,
  height: 10
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__pattern2)",
  d: "M23.133 28.45h9.203v9.102h-9.203z"
}));

var _ref13 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#logo_svg__c)"
}, /*#__PURE__*/React.createElement("path", {
  opacity: 0.75,
  d: "M27.743 37.098c2.294 0 4.154-1.84 4.154-4.108s-1.86-4.107-4.154-4.107c-2.293 0-4.153 1.839-4.153 4.107 0 2.269 1.86 4.108 4.153 4.108z",
  fill: "#fff"
}));

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M27.744 35.583c1.447 0 2.62-1.16 2.62-2.593 0-1.431-1.173-2.592-2.62-2.592-1.448 0-2.622 1.16-2.622 2.592 0 1.432 1.174 2.593 2.622 2.593z",
  fill: "#fff"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M21.02 15.547h1.245l-.078.564h.017c.052-.079.121-.16.207-.239a1.636 1.636 0 011.105-.427c.329 0 .586.05.777.15.19.1.329.238.415.414.086.176.132.386.138.624.006.238-.012.497-.052.777l-.319 2.29H23.18l.285-2.033c.017-.12.032-.244.044-.37a1.08 1.08 0 00-.025-.355.521.521 0 00-.163-.265c-.082-.069-.206-.102-.371-.102a.888.888 0 00-.42.09.756.756 0 00-.272.237c-.069.1-.121.212-.155.338a2.58 2.58 0 00-.077.394l-.294 2.068h-1.295l.583-4.155zM25.634 13.24h1.295l-.916 6.46h-1.295l.916-6.46zM26.86 15.547h1.295l-.587 4.153h-1.295l.587-4.153zm.077-1.308a.888.888 0 01.298-.524.937.937 0 01.264-.157c.098-.04.199-.06.302-.06a.62.62 0 01.496.217.637.637 0 01.143.527.802.802 0 01-.29.524.937.937 0 01-.263.157c-.099.04-.2.06-.302.06a.674.674 0 01-.501-.217.635.635 0 01-.126-.234.799.799 0 01-.02-.293zM28.398 15.547h1.244l-.077.564h.016c.053-.079.122-.16.208-.239a1.634 1.634 0 011.104-.427c.33 0 .587.05.777.15.191.1.33.238.415.414.086.176.132.386.139.624.006.238-.013.497-.053.777l-.318 2.29h-1.295l.285-2.033a9.3 9.3 0 00.044-.37c.01-.13.002-.247-.025-.355a.521.521 0 00-.164-.265c-.082-.069-.205-.102-.37-.102a.887.887 0 00-.42.09.755.755 0 00-.272.237c-.07.1-.122.212-.155.338-.036.125-.061.257-.078.394l-.293 2.068h-1.295l.582-4.155zM36.128 18.981a2.503 2.503 0 01-.867.607 2.576 2.576 0 01-1.905.06 1.824 1.824 0 01-.679-.439 1.725 1.725 0 01-.398-.688 2.037 2.037 0 01-.057-.897c.047-.33.15-.63.306-.898.16-.267.357-.497.591-.688.237-.19.503-.338.803-.44.3-.103.61-.153.932-.153.3 0 .564.052.794.154a1.4 1.4 0 01.562.44c.145.19.243.42.298.687.054.268.058.568.012.898l-.06.402h-3.008c.017.244.103.439.256.584.153.145.356.218.61.218.214 0 .398-.048.557-.141.16-.094.304-.216.436-.363l.817.657zm-.838-1.828a.675.675 0 00-.138-.555c-.128-.154-.308-.23-.545-.23a1.051 1.051 0 00-.691.242.949.949 0 00-.216.249.941.941 0 00-.122.294h1.712zM18.395 19.791c1.232 0 2.231-.988 2.231-2.207 0-1.219-.999-2.207-2.231-2.207-1.233 0-2.232.988-2.232 2.207 0 1.22 1 2.207 2.232 2.207z",
  fill: "#000"
});

var _ref16 = /*#__PURE__*/React.createElement("mask", {
  id: "logo_svg__d",
  maskUnits: "userSpaceOnUse",
  x: 15,
  y: 14,
  width: 7,
  height: 7
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__pattern3)",
  d: "M15.742 14.921h5.331v5.322h-5.331z"
}));

var _ref17 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#logo_svg__d)"
}, /*#__PURE__*/React.createElement("path", {
  opacity: 0.75,
  d: "M18.395 19.791c1.232 0 2.231-.988 2.231-2.207 0-1.219-.999-2.207-2.231-2.207-1.233 0-2.232.988-2.232 2.207 0 1.22 1 2.207 2.232 2.207z",
  fill: "#fff"
}));

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M18.395 18.65c.594 0 1.077-.477 1.077-1.066 0-.588-.483-1.065-1.078-1.065-.594 0-1.076.477-1.076 1.065 0 .589.482 1.066 1.076 1.066z",
  fill: "#fff"
});

var _ref19 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
  id: "logo_svg__pattern0",
  patternContentUnits: "objectBoundingBox",
  width: 1,
  height: 1
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#logo_svg__image0"
})), /*#__PURE__*/React.createElement("pattern", {
  id: "logo_svg__pattern1",
  patternContentUnits: "objectBoundingBox",
  width: 1,
  height: 1
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#logo_svg__image0"
})), /*#__PURE__*/React.createElement("pattern", {
  id: "logo_svg__pattern2",
  patternContentUnits: "objectBoundingBox",
  width: 1,
  height: 1
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#logo_svg__image0"
})), /*#__PURE__*/React.createElement("pattern", {
  id: "logo_svg__pattern3",
  patternContentUnits: "objectBoundingBox",
  width: 1,
  height: 1
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#logo_svg__image0"
})), /*#__PURE__*/React.createElement("image", {
  id: "logo_svg__image0",
  xlinkHref: "data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEBLAEsAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA"
}));

function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19);
}

export default __webpack_public_path__ + "static/logo.efc4b536.svg";
export { SvgLogo as ReactComponent };